import { useEffect, useState } from 'react'
import { useAuthContext } from 'context/AuthContext'
import { CIMSModule, CIMSPage } from '@cims-online/shared'
import { HomeOutlined } from '@ant-design/icons'
import ProjectLink from 'components/ProjectLink'
import { Layout, Menu } from 'antd'
import { useExternals } from './hooks/useExternals'
import { useImportsExports } from './hooks/useImportsExports'
import { useRFI } from './hooks/useRFI'
import { useCAS } from './hooks/useCAS'
import { useDS } from './hooks/useDS'
import { useFDC } from './hooks/useFDC'
import { useEJ } from './hooks/useEJ'
import { useConcrete } from './hooks/useConcrete'
import { useIssues } from './hooks/useIssues'
import { useIFI } from './hooks/useIFI'
import { useMaterials } from './hooks/useMaterials'
import { usePayItems } from './hooks/usePayItems'
import { useAdmin } from './hooks/useAdmin'
import { useRouteMatches } from 'hooks/useRouteMatches'
import CIMSLogo from 'components/CIMSLogo'
import { useWorkflows } from './hooks/useWorkflows'

export const ProjectSideNav: React.VFC<{
  collapsed: boolean
}> = ({ collapsed }) => {
  const { user } = useAuthContext()
  const { param } = useRouteMatches()
  const workflowId = param('workflowId')

  const pageId = !!workflowId
    ? `${workflowId}-${param('page')}`
    : CIMSPage.fromPath({
        module: param('module'),
        page: param('page'),
      })?.id ?? CIMSModule.Home.id

  const [openKeys, setOpenKeys] = useState<string[]>([])
  useEffect(() => {
    /**
     * Stuff needed to keep one menu open at a time
     */
    if (pageId === CIMSModule.Home.id) return setOpenKeys([])
    const moduleId = !!workflowId
      ? workflowId
      : CIMSPage.fromId(pageId)?.module?.id
    setOpenKeys(moduleId ? [moduleId] : [])
  }, [workflowId, pageId])

  const home = user
    ? {
        key: CIMSModule.Home.id,
        icon: <HomeOutlined />,
        label: <ProjectLink item={CIMSModule.Home}>Home</ProjectLink>,
      }
    : null

  return (
    <Layout.Sider
      collapsible
      collapsed={collapsed}
      collapsedWidth={0}
      trigger={null}
      width={300}
      style={{ overflowY: 'auto' }}
    >
      <CIMSLogo />
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={pageId ? [pageId] : []}
        openKeys={openKeys}
        onOpenChange={(keys) => {
          const latest = keys[keys.length - 1]
          setOpenKeys(latest ? [latest.toString()] : [])
        }}
        onSelect={({ key }) => {
          if (key === 'sharepoint' || key === 'photoViewer') return
        }}
        items={[
          ...useExternals(),
          home,
          useImportsExports(),
          useRFI(),
          useCAS(),
          useDS(),
          useFDC(),
          useEJ(),
          useConcrete(),
          useIssues(),
          useIFI(),
          useMaterials(),
          ...useWorkflows(),
          usePayItems(),
          useAdmin(),
        ]}
      />
    </Layout.Sider>
  )
}

export default ProjectSideNav
